import 'keen-ui/src/bootstrap'; // Required to setup Keen UI, should be imported only once in your project
import configure from 'keen-ui/src/configure';
import UiAlert from 'keen-ui/src/UiAlert.vue';
import UiAutocomplete from 'keen-ui/src/UiAutocomplete.vue';
import UiButton from 'keen-ui/src/UiButton.vue';
import UiCheckbox from 'keen-ui/src/UiCheckbox.vue';
import UiCheckboxGroup from 'keen-ui/src/UiCheckboxGroup.vue';
import UiConfirm from 'keen-ui/src/UiConfirm.vue';
import UiDatepicker from 'keen-ui/src/UiDatepicker.vue';
import UiFileupload from 'keen-ui/src/UiFileupload.vue';
import UiIcon from 'keen-ui/src/UiIcon.vue';
import UiIconButton from 'keen-ui/src/UiIconButton.vue';
import UiMenu from 'keen-ui/src/UiMenu.vue';
import UiModal from 'keen-ui/src/UiModal.vue';
import UiPopover from 'keen-ui/src/UiPopover.vue';
import UiProgressCircular from 'keen-ui/src/UiProgressCircular.vue';
import UiProgressLinear from 'keen-ui/src/UiProgressLinear.vue';
import UiRadioGroup from 'keen-ui/src/UiRadioGroup.vue';
import UiRippleInk from 'keen-ui/src/UiRippleInk.vue';
import UiSelect from 'keen-ui/src/UiSelect.vue';
import UiSlider from 'keen-ui/src/UiSlider.vue';
import UiSnackbarContainer from 'keen-ui/src/UiSnackbarContainer.vue';
import UiSwitch from 'keen-ui/src/UiSwitch.vue';
import UiTextbox from 'keen-ui/src/UiTextbox.vue';
import UiTooltip from 'keen-ui/src/UiTooltip.vue';

import { LocaleEnum } from '../enums';

configure(UiConfirm, {
  autofocus: 'none',
  transition: 'scale-up'
});

configure(UiDatepicker, {
  orientation: 'landscape'
});

configure(UiIcon, {
  iconSet: 'eicon'
});

configure(UiMenu, {
  raised: true
});

configure(UiModal, {
  transition: 'scale-up'
});

configure(UiProgressCircular, {
  size: 50
});

configure(UiSlider, {
  step: 1,
  showMarker: true
});

configure(UiSnackbarContainer, {
  duration: 4000,
  position: 'center'
});

export const getDatepickerI18nConfig = (locale: LocaleEnum): any => {
  const config: any = {
    [LocaleEnum.ENGLISH]: () => ({}),
    [LocaleEnum.SPANISH]: () => {
      const months = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre'
      ];
      const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
      return {
        startOfWeek: 1,
        lang: {
          months: {
            full: months,
            abbreviated: months.map((month: string) => month.substr(0, 3))
          },
          days: {
            full: days,
            abbreviated: days.map((day: string) => day.substr(0, 3)),
            initials: ['D', 'L', 'M', 'X', 'J', 'V', 'S']
          }
        }
      };
    }
  }[locale]();
  config.customFormatter = (date: Date) => date.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  return config;
};

export {
  UiAlert,
  UiAutocomplete,
  UiButton,
  UiCheckbox,
  UiCheckboxGroup,
  UiConfirm,
  UiDatepicker,
  UiFileupload,
  UiIcon,
  UiIconButton,
  UiMenu,
  UiModal,
  UiPopover,
  UiProgressCircular,
  UiProgressLinear,
  UiRadioGroup,
  UiRippleInk,
  UiSelect,
  UiSlider,
  UiSnackbarContainer,
  UiSwitch,
  UiTextbox,
  UiTooltip
};
